export default __webpack_public_path__ + "static/BannerUspWithTextAndTwoBlocks-b846c9174f2f6d47f13204beb7889511.jpg";